<template lang="html">
  <div class="studio-shots">
    <div class="col-twelve text-left">
      <input type="file" accept="image/png,image/jpeg" name="image" v-on:change="uploadImage" id="new-shot">
      <button class="big-purple-button" @click="chooseImage">Upload</button>
      <div class="message">{{ errorText }}</div>
    </div>
    <div class="shots-wrapper col-twelve no-padding-left no-padding-right sortable" id="studio_shots_sortable">
      <studio-shot v-for="shot in shots" :shot="shot" :key="shot.id" @shotDeleted="deleteShot"></studio-shot>
      <div class="col-three" v-if="loading">
        <div class="studio-shots-loader"></div>
      </div>
    </div>
  </div>
</template>

<script>
// Component to show list of studio shots

export default {
  props: ['default'],
  data() {
    return {
      shots: [],
      errorText: '',
      loading: false
    };
  },
  methods: {
    deleteShot(deletedShot) {
      this.shots = this.shots.filter((shot) => {
        return shot.id !== deletedShot.id;
      });
    },
    chooseImage() {
      window.$('.studio-shots input[type=file]').click();
    },
    uploadImage() {
      let formData = new FormData();
      let image = document.getElementById('new-shot').files[0];
      this.loading = true;
      if (!image.type.match('image.*')) {
        return false;
      }

      formData.append('image', image);
      formData.append('need_duplicate', 1);
      formData.append('entity_type', 'studio_shot');

      axios.post('/ajax/image/upload', formData, {
        headers: {'content-type': 'multipart/form-data'}
      })
        .then((response) => {
          this.loading = false;
          this.initCrop(response);
        }).catch((error) => {
          this.loading = false;
          this.errorText = 'Please upload correct image (.JPG, .PNG, 700x700px minimum)';
          window.$('.studio-shots .message').addClass('text-danger');
        });
    },
    initCrop(response) {
      let self = this;
      let modalHtml = window.$('#crop-image').clone();
      let cropper = null;
      window.$('#image-to-crop').attr('src', response.data['public_path']);
      window.$('#crop-image').modal({
        backdrop: 'static'
      });
      window.$('#crop-image').on('shown.bs.modal', function () {
        if (cropper) {
          cropper.destroy();
        }
        let image = document.getElementById('image-to-crop');

        cropper = new Cropper(image, {
          viewMode: 2,
          autoCropArea: 1,
          aspectRatio: 1,
          autoCrop: true,
          restore: false,
          minCanvasWidth: 700,
          crop: function (cropDetails) {
            if (Math.ceil(cropDetails.detail.width) < 700 || Math.ceil(cropDetails.detail.height) < 700) {
              cropper.setData({width: 700, height: 700});
            }
          }
        });
        window.$('.rotate-right').click(function (event) {
          event.preventDefault();
          cropper.rotate(45);
        });
        window.$('.rotate-left').click(function (event) {
          event.preventDefault();
          cropper.rotate(-45);
        });
        window.$('.zoom-in').click(function (event) {
          event.preventDefault();
          cropper.zoom(0.1);
        });
        window.$('.zoom-out').click(function (event) {
          event.preventDefault();
          cropper.zoom(-0.1);
        });
        window.$('.cancel-crop').click(function (event) {
          event.preventDefault();
          cropper.reset();
        });
        window.$('.save-crop').click(function (click) {
          click.preventDefault();
          let cropInfo = cropper.getData(true);
          cropInfo.file_id = response.data['file_id'];

          // apply crop changes and set
          axios.post('/profile/ajax/upload/shot', cropInfo)
            .then((transformResponse) => {
              this.errorText = '';
              window.$('.studio-shots .message').removeClass('text-danger');
              self.shots.push(transformResponse.data);
              let masonry = window.$('.masonry').data('masonry');
              cropper.destroy();
              window.$('#crop-image').modal('hide');
            });
        });
      });
      window.$('button.delete-image').click((click) => {
        click.preventDefault();
        cropper.destroy();
        window.$('#crop-image').modal('hide');
      });
      window.$('#crop-image').on('hidden.bs.modal', () => {
        window.$('#crop-image').after(modalHtml).remove();
      });
    },
    changeOrder(studioShotIds) {
      axios.put('/api/studio-shots/change-order', {studioShotIds}).then(() => {
        toastr.success('Order was changed successfully');
      }).catch(() => {
        toastr.error('Something went wrong. Please try again later');
      });
    },
    initSortable() {
      let self = this;
      $('#studio_shots_sortable').sortable({
        stop: function () {
          let studioShotIds = [];

          $('#studio_shots_sortable .sortable-item').each(function () {
            studioShotIds.push($(this).data('resource-id'));
          });

          self.changeOrder(studioShotIds);
        }
      });
    },
  },
  mounted() {
    if (this.default) {
      this.default.forEach((shot) => {
        this.shots.push(shot);
      });
    }

    this.initSortable();
  }
};
</script>

<style lang="scss">
  .studio-shots {
    margin-top: 15px;
    input[type=file] {
      display: none;
    }
    .message {
      vertical-align: middle;
      display: inline-block;
    }
    .shots-wrapper {
      margin-top: 15px;
    }
  }

  .studio-shots-loader {
    display: block;
    margin: 10px auto 0;
    width: 50px;
    height: 50px;
    border: 9px solid rgba(0, 0, 0, 0.2);
    border-right-color: #6E1B56;
    border-radius: 50%;
    animation: loading-bar-spinner 0.6s linear;
    animation-iteration-count: infinite;
  }

  @keyframes loading-bar-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>